import React, { useEffect } from "react";
import { removeUserSession } from "../Utils/Common";
import { useNavigate } from "react-router-dom";

function Logout() {

    const navigate = useNavigate();

    useEffect(() => {
        console.log('click me');
        removeUserSession();
        navigate("/login");

    }, []);

    // const LogoutSession = () => {
    //     console.log('click me');
    //     removeUserSession();
    //     navigate("/login");
    // };

    return (<div className="container-fluid ">
        <div className=" container fs-1 text-center">
            {/* <h1 style={{ marginTop: "300px" }}>Logout Page </h1> */}
        </div>
    </div>);

}

export default Logout